import React, { useEffect, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import Table from "@mui/material/Table";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import {
  arrow_icon,
  delete_icon,
  drag,
  edit_icon,
  Search_icon,
} from "../../assets/img";
import { deletes, get, post, put } from "../../Services/ApiHandler";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";

const TutorialLanguages = () => {
  const [show, setShow] = useState(false);
  const [list, setList] = useState([]);

  const [selected, setSelected] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [language, setLanguage] = useState({});
  const [search, setSearch] = useState("");

  //drag and drop
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  const handleSort = () => {
    let items = [...list];
    const draggedItemContent = items.splice(dragItem.current, 1)[0];
    items.splice(dragOverItem.current, 0, draggedItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setList(items);
    if (items.length > 1) setShow(true);
  };

  const onAdd = (e) => {
    e.preventDefault();
    let trimmed = language?.name?.trim();
    let display_name_trimmed = language?.display_name?.trim();
    if (trimmed && display_name_trimmed) {
      setLanguages((prev) => [
        language,
        ...prev.filter((item) => item?.display_name != language?.display_name),
      ]);
      setLanguage({});
    }
  };

  const handleRemove = async (index) => {
    setLanguages((prev) => prev.filter((_, ind) => ind != index));
  };

  const handleClosePop = () => {
    setSelected(false);
    setLanguage({});
    setLanguages([]);
  };

  const handleFilter = (data, search) => {
    if (!search || !data) return data ?? [];
    let filtered = (data ?? []).filter((item) =>
      item?.name?.toUpperCase().includes(search?.toUpperCase()),
    );
    if (filtered?.length === 0) toast.info("No Records Found..");
    return filtered;
  };

  //api functions

  const getList = async () => {
    let res = await get(URLS.LANGUAGE_LIST_TABLE);
    if (res?.status === "success") {
      setList(
        res?.data?.map((item) => ({ ...item, display_name: item?.icon })),
      );
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const savePosition = async () => {
    const payload = list.map((item, index) => ({
      id: item.id,
      position: index + 1,
    }));
    const res = await post(`${URLS.MASTERURL}positions/`, payload);
    if (res?.status === "success") {
      toast.success(res?.message || "Position updated");
      setShow(false);
    }
  };

  const handleSubmit = async () => {
    let isAdd = selected?.type === "add";
    if (
      (isAdd && languages.length === 0) ||
      (!isAdd && (!selected?.data?.name || !selected?.data?.display_name))
    ) {
      toast.error(
        isAdd && languages.length === 0
          ? "Please Add atleast one Language"
          : !selected?.data?.name
            ? "Language Cannot be Empty"
            : "Display Name Cannot be Empty",
      );
      return;
    }
    
    let url = isAdd
      ? URLS.LANGUAGE_CREATE
      : URLS.LANGUAGE_EDIT + selected?.data?.id + "/";
    let method = isAdd ? post : put;
    let payload = isAdd
      ? languages
      : {
          display_name: selected?.data?.display_name,
          name: selected?.data?.name,
        };
    let res = await method(url, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
      handleClosePop();
    }
  };

  const handleStatus = async (d) => {
    let res = await post(`${URLS.MASTERURL}${d.id}/status/`, {
      status: !d.status,
      type: 11,
    });
    if (res?.status === "success") {
      toast.success("Language Status Updated");
      setList((prev) =>
        prev.map((item) =>
          item?.id === d?.id ? { ...item, status: !d?.status } : item,
        ),
      );
    }
  };

  const handleDelete = async (data) => {
    let res = await deletes(URLS.LANGUAGE_DELETE + data?.id + "/");
    if (res?.status === "success") {
      setList((prev) => prev.filter((item) => item?.id != data?.id));
      toast.success(res?.message);
      handleClosePop();
    }
  };

  return (
    <div>
      <Topbar header={"Languages"} back={true} />
      <hr className="mt-3 mb-3" style={{ backgroundColor: "#D1D1D6" }}></hr>

      <div className="d-flex ac-jb">
        <h2 className="f1 mt-3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
          Total No: {String(list?.length).padStart(2, 0)}
        </h2>
        <div className="d-flex ac-js gap-3">
          <div className="search-input">
            <input
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" />
          </div>
          <button
            onClick={() => setSelected({ type: "add" })}
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
          >
            {" "}
            + Add New
          </button>

          {show && (
            <button
              onClick={savePosition}
              className="submit-btn f2"
              style={{ minWidth: "120px" }}
            >
              Save
            </button>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="mt-5" style={{ width: "100%", overflow: "auto" }}>
        <table
          className="table-design-new"
          style={{ width: "98%", borderRadius: "10px" }}
        >
          <thead>
            <tr className="border-bottom w-100">
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                S.No
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Display Name
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Language
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Status
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {handleFilter(list, search)?.map((item, index) => (
              <tr
                key={index}
                className="list-item p-2"
                // draggable
                onDragStart={() => (dragItem.current = index)}
                onDragEnter={() => (dragOverItem.current = index)}
                onDragEnd={handleSort}
                onDragOver={(e) => e.preventDefault()}
              >
                <td className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 red list-data ">
                  {index + 1}
                </td>
                <td className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  {item?.display_name}
                </td>
                <td className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  {item?.name}
                </td>
                <td className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  <button
                    onClick={() => handleStatus(item)}
                    className={item.status ? "active-btn" : "deactive-btn"}
                  >
                    {item.status ? "Active" : "De-active"}
                  </button>
                </td>
                <td>
                  <div className="d-flex ac-js gap-2">
                    <button
                      onClick={() => setSelected({ type: "edit", data: item })}
                      className="cust-btn "
                    >
                      <img src={edit_icon} alt="" className="edit-btn" />
                    </button>

                    <button
                      onClick={() =>
                        setSelected({ type: "delete", data: item })
                      }
                      className="cust-btn "
                    >
                      <img src={delete_icon} alt="" className="edit-btn" />
                    </button>
                  </div>
                </td>
                <td className="position-relative">
                  <div className="drag-box">
                    <img src={drag} className="drag-img" alt="" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {Boolean(selected?.type === "add" || selected.type === "edit") && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {selected?.type === "add" ? "Add" : "Edit"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  handleClosePop();
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                {selected?.type === "add" && (
                  <div>
                    <h3 className="f4 text-start fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 mb-1 mt-3">
                      Display Name
                    </h3>
                    <div className="d-flex ae-jb input-border p-1 mb-1">
                      <input
                        type="text"
                        value={language?.display_name ?? ""}
                        onChange={(e) => {
                          setLanguage((prev) => ({
                            ...prev,
                            display_name: e.target.value,
                          }));
                        }}
                        placeholder="Display name"
                        className="input-box"
                      />
                    </div>

                    <h3 className="f4 text-start fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 mb-1 mt-3">
                      Name
                    </h3>

                    <div className="d-flex ae-jb input-border p-1">
                      <textarea
                        style={{ maxHeight: "80px" }}
                        value={language?.name ?? ""}
                        onChange={(e) => {
                          setLanguage((prev) => ({
                            ...prev,
                            name: e.target.value,
                          }));
                        }}
                        placeholder="Write Here...."
                        className="border-0 mb-3 w-80"
                      />
                      <button
                        onClick={onAdd}
                        className="submit-btn p-1"
                        style={{ minWidth: "100px" }}
                      >
                        Add
                      </button>
                    </div>
                    {languages?.length > 0 && (
                      <ul
                        className="input-border overflow-scroll mt-2"
                        style={{ minHeight: "50px", maxHeight: "200px" }}
                      >
                        {languages?.map((item, index) => (
                          <li key={index} className="d-flex as-js gap-3 mt-2">
                            <img
                              src={arrow_icon}
                              className="bullet-btn"
                              alt=""
                            />
                            <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                              {item?.display_name}
                            </p>
                            <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                              {item?.name}
                            </p>
                            <img
                              src={delete_icon}
                              className="delete-btn"
                              onClick={() => handleRemove(index)}
                              alt="delete"
                            />
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
                {selected?.type === "edit" && (
                  <div>
                    <h3 className="f4 text-start fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 mb-1 mt-3">
                      Display Name
                    </h3>
                    <div className="d-flex ae-jb input-border p-1 mb-1">
                      <input
                        type="text"
                        value={selected?.data?.display_name ?? ""}
                        onChange={(e) => {
                          setSelected((prev) => ({
                            ...prev,
                            data: {
                              ...prev.data,
                              display_name: e.target.value,
                            },
                          }));
                        }}
                        placeholder="Display Name"
                        className="input-box"
                      />
                    </div>

                    <h3 className="f4 text-start fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 mb-1 mt-3">
                      Name
                    </h3>
                    <div className="d-flex ae-jb input-border p-1 mb-1">
                      <input
                        type="text"
                        value={selected?.data?.name ?? ""}
                        onChange={(e) => {
                          setSelected((prev) => ({
                            ...prev,
                            data: { ...prev.data, name: e.target.value },
                          }));
                        }}
                        placeholder="Language"
                        className="input-box"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex ac-je px-2 mt-4">
              <button onClick={handleSubmit} className="submit-btn f2 w-40 p-2">
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {selected.type === "delete" && (
        <div className="img-popup-design">
          <div className="img-popup">
            {Boolean(selected?.data?.active_video) && (
              <p className="text-danger mb-2 mt-2">
                This language has mapped videos.
              </p>
            )}
            <p>Are you sure, want to Delete?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(selected?.data)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => handleClosePop()}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TutorialLanguages;
